/* Квіз «Знайдіть свій аромат» (sections/scent-quiz.liquid).

   Перенос React-компонента з quiz.sistersaroma.com без фреймворку: ті самі
   екрани (intro → 7 питань → результат), класи, анімації, таймер
   автопереходу і ті самі події:
   - dataLayer: quiz_start, quiz_answer, quiz_complete, quiz_redirect;
   - Meta Pixel квізу (trackSingle, лише після згоди на маркетингові cookie):
     PageView, QuizStart, QuizComplete, QuizProductClick і QuizRedirect_<АРОМАТ>.
   ?qa в адресі вимикає автоперехід (події при цьому йдуть). */
(() => {
  const root = document.querySelector('[data-sa-quiz]');
  const dataEl = document.getElementById('sa-quiz-data');
  if (!root || !dataEl) return;

  const D = JSON.parse(dataEl.textContent);
  const T = D.t;
  const Q = D.questions;
  const R = D.results;
  const KEYS = ['sugar', 'bloom', 'cherry', 'pur', 'almond'];
  const SECONDS = D.seconds || 6;
  const QA = new URLSearchParams(location.search).has('qa');
  const REDIRECT_EVENT = {
    sugar: 'QuizRedirect_SUGAR_PORN', bloom: 'QuizRedirect_BLOOM_HUSTLE',
    cherry: 'QuizRedirect_CHERRY_PORN', pur: 'QuizRedirect_PUR_PUR', almond: 'QuizRedirect_ALMOND_DADDY',
  };
  const META_EVENT = { quiz_start: 'QuizStart', quiz_complete: 'QuizComplete', quiz_redirect: 'QuizProductClick' };

  const $ = (sel) => root.querySelector(sel);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const pad = (n) => String(n).padStart(2, '0');
  const uid = () => 'saq_' + (crypto.randomUUID ? crypto.randomUUID().replaceAll('-', '') : Date.now() + Math.random().toString(16).slice(2));

  /* ---------- UTM та ідентифікатори кампаній → посилання на товар ---------- */
  const ATTR_KEY = 'sa_quiz_attribution_v1';
  const ATTR_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id',
    'utm_source_platform', 'campaign_id', 'adset_id', 'ad_id', 'placement', 'site_source_name',
    'gclid', 'gbraid', 'wbraid', 'fbclid'];
  function pickAttribution(search) {
    const src = new URLSearchParams(search);
    const out = new URLSearchParams();
    ATTR_PARAMS.forEach((k) => { const v = src.get(k); if (v && v.length <= 500) out.set(k, v); });
    const s = out.toString();
    return s ? '?' + s : '';
  }
  const attribution = (() => {
    const fresh = pickAttribution(location.search);
    try {
      if (fresh) { sessionStorage.setItem(ATTR_KEY, fresh); return fresh; }
      return sessionStorage.getItem(ATTR_KEY) || '';
    } catch (e) { return fresh; }
  })();
  function withAttribution(url) {
    const u = new URL(url, location.origin);
    const extra = new URLSearchParams(attribution.replace(/^\?/, ''));
    extra.forEach((v, k) => { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
    return u.toString();
  }

  /* ---------- Meta Pixel квізу ---------- */
  const pixel = {
    queue: [],
    ready: false,
    send(ev) {
      if (!D.pixel) return;
      if (this.ready) this.fire(ev); else this.queue.push(ev);
    },
    fire(ev) {
      const fbq = window.fbq;
      const opts = { eventID: ev.id };
      if (ev.name === 'PageView') fbq('trackSingle', D.pixel, 'PageView', {}, opts);
      else fbq('trackSingleCustom', D.pixel, ev.name, ev.params, opts);
    },
    load() {
      if (this.ready || !D.pixel) return;
      let fbq = window.fbq;
      if (!fbq) {
        // стандартний завантажувач fbevents.js; якщо магазин уже підвантажив
        // свій піксель, використовуємо той самий fbq
        fbq = window.fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
        if (!window._fbq) window._fbq = fbq;
        fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
        const s = document.createElement('script');
        s.async = true; s.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(s);
      }
      if (!window.__saQuizMetaInitialized) { fbq('init', D.pixel); window.__saQuizMetaInitialized = true; }
      this.ready = true;
      this.queue.splice(0).forEach((ev) => this.fire(ev));
    },
  };

  function metaParams(name, resultKey, method) {
    const p = { content_category: 'perfume_quiz', quiz_id: D.quizId, quiz_version: D.quizVersion };
    if (resultKey) { p.result_key = resultKey; p.result_name = R[resultKey].name; }
    if ((name === 'QuizProductClick' || name.startsWith('QuizRedirect_')) && method) p.redirect_method = method;
    return p;
  }

  function track(event, params = {}) {
    const ev = { event, quiz_id: D.quizId, quiz_version: D.quizVersion, ...params };
    const metaName = META_EVENT[event];
    if (metaName) ev.meta_event_id = uid();
    (window.dataLayer = window.dataLayer || []).push(ev);
    window.dispatchEvent(new CustomEvent('sisters-aroma:quiz-event', { detail: ev }));
    if (!metaName) return;
    pixel.send({ id: ev.meta_event_id, name: metaName, params: metaParams(metaName, params.result_key, params.redirect_method) });
    if (metaName === 'QuizProductClick' && params.result_key) {
      const name = REDIRECT_EVENT[params.result_key];
      pixel.send({ id: ev.meta_event_id + '_product', name, params: metaParams(name, params.result_key, params.redirect_method) });
    }
  }

  // Згода: той самий Customer Privacy API, що й у assets/tracking.js
  function marketingAllowed() {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return false;
    try {
      return Boolean(cp.marketingAllowed())
        && (typeof cp.saleOfDataAllowed !== 'function' || Boolean(cp.saleOfDataAllowed()));
    } catch (e) { return false; }
  }
  // setTimeout — щоб піксель магазину (tracking.js) встиг відправити свій
  // PageView раніше, ніж ми додамо до fbq піксель квізу
  const tryPixel = () => { if (marketingAllowed()) setTimeout(() => pixel.load(), 0); };
  document.addEventListener('visitorConsentCollected', tryPixel);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) tryPixel(); });
  } else {
    tryPixel();
  }
  pixel.send({ id: uid(), name: 'PageView' });

  /* ---------- Стан ---------- */
  const st = {
    phase: 'intro', index: 0, answers: [], selected: null, result: null,
    leaving: false, seconds: SECONDS, paused: false, redirected: false, timer: null, leaveTimer: null,
  };
  const stage = $('[data-stage]');
  const intro = $('[data-intro]');
  const progressNumber = $('[data-progress-number]');
  const progress = $('[data-progress]');
  const progressBar = $('[data-progress-bar]');

  function setMotion(e, direction) {
    const instant = (e && e.detail === 0) || matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.dataset.motion = instant ? 'instant' : 'full';
    root.dataset.direction = direction;
    return instant;
  }

  function setPhase(phase) {
    const prev = st.phase;
    st.phase = phase;
    root.classList.remove('phase-intro', 'phase-quiz', 'phase-result');
    root.classList.add('phase-' + phase);
    intro.hidden = phase !== 'intro';
    const inQuiz = phase === 'quiz';
    [progressNumber, progress, progressBar].forEach((el) => { el.hidden = !inQuiz; });
    if (phase !== 'intro') stage.hidden = false;
    if (phase === 'intro') { stage.innerHTML = ''; stage.hidden = true; }
    if (phase !== 'intro' || prev !== 'intro') window.scrollTo({ top: 0, behavior: 'instant' });
    hero.setRunning(phase === 'intro');
    if (phase === 'intro' && prev !== 'intro') $('[data-intro-title]').focus();
  }

  /* ---------- Обкладинки першого екрана: зміна кожні 6 с ---------- */
  const hero = (() => {
    const slides = [...root.querySelectorAll('.hero-slide')];
    const toggle = $('[data-hero-toggle]');
    const loaded = new Set();
    const failed = new Set();
    let active = 0;
    let stopped = false;
    let running = true;
    let timer = null;

    slides.forEach((slide, i) => {
      const img = slide.querySelector('img');
      const ok = () => { loaded.add(i); failed.delete(i); schedule(); };
      const bad = () => { failed.add(i); if (i === active) show(next()); };
      if (img.complete) (img.naturalWidth > 0 ? ok : bad)();
      img.addEventListener('load', ok);
      img.addEventListener('error', bad);
    });

    function next() {
      for (let s = 1; s < slides.length; s += 1) {
        const i = (active + s) % slides.length;
        if (loaded.has(i) && !failed.has(i)) return i;
      }
      return active;
    }
    function show(i) {
      active = i;
      slides.forEach((s, j) => { s.classList.toggle('is-active', j === i); s.setAttribute('aria-hidden', j !== i); });
      root.dataset.cover = slides[i].dataset.cover;
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (stopped || !running || document.hidden) return;
      timer = setTimeout(() => { if (!document.hidden) show(next()); }, 6000);
    }
    toggle.addEventListener('click', () => {
      stopped = !stopped;
      toggle.setAttribute('aria-pressed', stopped);
      toggle.textContent = stopped ? T.coversResume : T.coversPause;
      schedule();
    });
    document.addEventListener('visibilitychange', schedule);
    return { setRunning(v) { running = v; schedule(); } };
  })();

  /* ---------- Питання ---------- */
  function renderQuestion(enter = true) {
    const n = st.index;
    const q = Q[n];
    const photoGrid = D.photoGrid.includes(n);
    progressNumber.textContent = `${pad(n + 1)} / ${pad(Q.length)}`;
    progress.value = n + 1;
    progress.max = Q.length;
    progress.setAttribute('aria-label', `${T.question} ${n + 1} / ${Q.length}`);
    progressBar.firstElementChild.style.transform = `scaleX(${(n + 1) / Q.length})`;

    const cards = q.options.map((o, i) => {
      const media = o.image
        ? `<span class="answer-media"><img class="answer-image" src="${esc(o.image)}" alt="" width="525" height="525" loading="eager" decoding="async"></span>`
        : `<span class="answer-index" aria-hidden="true">0${i + 1}</span>`;
      const detail = o.detail ? `<small>${esc(o.detail)}</small>` : '';
      return `<div class="answer-item" style="--stagger:${i * 35}ms">
        <button type="button" class="sa-btn sa-btn--outline answer-card" aria-pressed="${st.selected === o.result}" data-answer="${o.result}">
          ${media}<span class="answer-text"><strong>${esc(o.label)}</strong>${detail}</span>
        </button></div>`;
    }).join('');

    stage.innerHTML = `
      <section class="question-layout ${photoGrid ? 'question-photo-grid' : ''} ${enter ? 'scene-enter' : ''}">
        <div class="question-content">
          <div class="question-heading">
            <p class="question-eyebrow">${esc(q.eyebrow)}</p>
            <h1 tabindex="-1">${esc(q.title)}</h1>
            <p>${esc(q.hint)}</p>
          </div>
          <fieldset class="answer-grid ${photoGrid ? 'photo-grid' : ''}">
            <legend class="sr-only">${esc(q.title)}</legend>
            ${cards}
          </fieldset>
          <div class="question-actions">
            <button type="button" class="sa-btn sa-btn--ghost back-button" data-back>${esc(T.back)}</button>
            <button type="button" class="sa-btn primary-pill next-button" data-next ${st.selected ? '' : 'disabled'}>${esc(n === Q.length - 1 ? T.reveal : T.next)}</button>
          </div>
        </div>
      </section>`;
    stage.querySelector('h1').focus();
  }

  function syncSelection() {
    stage.querySelectorAll('[data-answer]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.answer === st.selected));
    stage.querySelector('[data-next]').disabled = !st.selected || st.leaving;
  }

  function counts(list) {
    return KEYS.reduce((acc, k) => { acc[k] = list.filter((a) => a === k).length; return acc; }, {});
  }
  function winner(list) {
    if (!list.length) return KEYS[0];
    const c = counts(list);
    const top = Math.max(...Object.values(c));
    const leaders = KEYS.filter((k) => c[k] === top);
    if (leaders.length === 1) return leaders[0];
    for (let i = list.length - 1; i >= 0; i -= 1) if (leaders.includes(list[i])) return list[i];
    return leaders[0];
  }

  function start(e) {
    setMotion(e, 'forward');
    Object.assign(st, { index: 0, answers: [], selected: null, result: null, redirected: false });
    setPhase('quiz');
    renderQuestion();
    track('quiz_start');
  }

  function back(e) {
    if (st.leaving) return;
    setMotion(e, 'back');
    if (st.index === 0) { st.selected = null; setPhase('intro'); return; }
    st.index -= 1;
    st.selected = st.answers[st.index] || null;
    renderQuestion();
  }

  function next(e) {
    if (!st.selected || st.leaving) return;
    const instant = setMotion(e, 'forward');
    const n = st.index;
    const q = Q[n];
    const answers = [...st.answers];
    const prev = answers[n] || null;
    answers[n] = st.selected;
    const ai = q.options.findIndex((o) => o.result === st.selected);
    if (prev !== st.selected) {
      track('quiz_answer', {
        question_id: `q${pad(n + 1)}`,
        question_number: n + 1,
        answer_id: `q${pad(n + 1)}_a${ai + 1}`,
        answer_label: (q.options[ai] && q.options[ai].label) || '',
        result_key: st.selected,
        result_name: R[st.selected].name,
        answer_changed: prev !== null,
      });
    }
    st.leaving = true;
    const section = stage.querySelector('.question-layout');
    section.classList.remove('scene-enter');
    section.classList.add('scene-leave');
    stage.querySelectorAll('button').forEach((b) => { if (b.dataset.answer || b.dataset.next !== undefined) b.disabled = true; });
    st.leaveTimer = setTimeout(() => {
      st.answers = answers;
      st.leaving = false;
      st.leaveTimer = null;
      if (n === Q.length - 1) {
        const key = winner(answers);
        const c = counts(answers);
        const top = Math.max(...Object.values(c));
        st.result = key;
        st.seconds = SECONDS;
        st.paused = false;
        st.redirected = false;
        setPhase('result');
        renderResult();
        track('quiz_complete', {
          result_key: key, result_name: R[key].name, result_score: c[key],
          total_questions: Q.length, tie_break_used: Object.values(c).filter((v) => v === top).length > 1,
        });
        tick();
      } else {
        st.index = n + 1;
        st.selected = answers[n + 1] || null;
        renderQuestion();
      }
    }, instant ? 0 : 170);
  }

  /* ---------- Результат ---------- */
  function destination() { return withAttribution(R[st.result].url); }

  function redirectText() {
    if (QA) return T.qa;
    if (st.paused) return T.paused;
    return T.redirect.replace('%s', st.seconds);
  }

  function renderResult() {
    const r = R[st.result];
    stage.innerHTML = `
      <section class="result-layout scene-enter">
        <div class="result-copy">
          <p class="sr-only" aria-live="polite">${esc(T.resultTitle)} ${esc(r.name)}</p>
          <div class="result-heading">
            <p class="result-kicker">${esc(T.kicker)}</p>
            <h1 tabindex="-1">${esc(r.name)}</h1>
            <p class="result-description">${esc(r.description)}</p>
          </div>
          <figure class="result-stage result-stage-${st.result}">
            <img src="${esc(r.image)}" alt="${esc(r.name)}" fetchpriority="high" decoding="async" sizes="(max-width: 820px) 100vw, 520px">
          </figure>
          <div class="result-controls">
            <div class="redirect-panel">
              <p data-redirect-text>${esc(redirectText())}</p>
              <div class="redirect-line" aria-hidden="true"><span data-redirect-line></span></div>
            </div>
            <div class="result-actions">
              <a class="primary-pill result-link" href="${esc(destination())}" data-go>${esc(T.goNow)}</a>
              ${QA ? '' : `<button type="button" class="sa-btn sa-btn--ghost pause-button" aria-pressed="false" data-pause>${esc(T.pause)}</button>`}
              <button type="button" class="sa-btn sa-btn--ghost restart-button" data-restart>${esc(T.restart)}</button>
            </div>
          </div>
        </div>
      </section>`;
    updateRedirect();
    stage.querySelector('h1').focus();
  }

  function updateRedirect() {
    const text = stage.querySelector('[data-redirect-text]');
    const line = stage.querySelector('[data-redirect-line]');
    if (!text) return;
    text.textContent = redirectText();
    line.style.transform = `scaleX(${QA || st.paused ? 0 : st.seconds / SECONDS})`;
    const pause = stage.querySelector('[data-pause]');
    if (pause) { pause.setAttribute('aria-pressed', st.paused); pause.textContent = st.paused ? T.resume : T.pause; }
  }

  function tick() {
    clearTimeout(st.timer);
    if (st.phase !== 'result' || QA || st.paused) return;
    if (st.seconds <= 0) {
      if (!st.redirected) {
        st.redirected = true;
        track('quiz_redirect', { result_key: st.result, result_name: R[st.result].name, destination_url: destination(), redirect_method: 'automatic' });
      }
      location.assign(destination());
      return;
    }
    st.timer = setTimeout(() => { st.seconds -= 1; updateRedirect(); tick(); }, 1000);
  }

  function restart(e) {
    setMotion(e, 'back');
    clearTimeout(st.timer);
    Object.assign(st, { index: 0, answers: [], selected: null, result: null, seconds: SECONDS, paused: false, redirected: false });
    setPhase('intro');
  }

  /* ---------- Події ---------- */
  $('[data-start]').addEventListener('click', start);
  stage.addEventListener('click', (e) => {
    const t = e.target.closest('button, a');
    if (!t) return;
    if (t.dataset.answer) { if (!st.leaving) { st.selected = t.dataset.answer; syncSelection(); } return; }
    if (t.hasAttribute('data-back')) return back(e);
    if (t.hasAttribute('data-next')) return next(e);
    if (t.hasAttribute('data-pause')) { st.paused = !st.paused; updateRedirect(); tick(); return; }
    if (t.hasAttribute('data-restart')) return restart(e);
    if (t.hasAttribute('data-go') && !st.redirected) {
      st.redirected = true;
      track('quiz_redirect', { result_key: st.result, result_name: R[st.result].name, destination_url: destination(), redirect_method: 'manual' });
    }
  });
  stage.hidden = true;
})();
